import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useState } from "react";
import { LayoutGrid, Table } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TransactionTable } from "@/components/history/TransactionTable";
import { TransactionCharts } from "@/components/history/TransactionCharts";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ErrorState } from "@/components/owner/ErrorState";

const History = () => {
  const [period, setPeriod] = useState("all");
  const [transactionType, setTransactionType] = useState("all");
  const [viewMode, setViewMode] = useState<"table" | "charts">("table");

  const { data: transactions, isError, error } = useQuery({
    queryKey: ['transactions', period, transactionType],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Non authentifié");

      console.log("Fetching transactions with filters:", { period, transactionType });

      const { data, error } = await supabase
        .from('poultry_transactions')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data;
    }
  });

  if (isError) {
    console.error("Error fetching transactions:", error);
    return <ErrorState message="Une erreur s'est produite lors du chargement de l'historique." />;
  }

  return (
    <DashboardLayout userType="owner">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold">Historique des mouvements</h1>
          <div className="flex gap-4">
            <div className="flex items-center gap-2">
              <Button
                variant={viewMode === "table" ? "default" : "outline"}
                size="icon"
                onClick={() => setViewMode("table")}
                title="Vue tableau"
              >
                <Table className="h-4 w-4" />
              </Button>
              <Button
                variant={viewMode === "charts" ? "default" : "outline"}
                size="icon"
                onClick={() => setViewMode("charts")}
                title="Vue graphiques"
              >
                <LayoutGrid className="h-4 w-4" />
              </Button>
            </div>
            <Select value={period} onValueChange={setPeriod}>
              <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Sélectionner une période" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tout l'historique</SelectItem>
                <SelectItem value="today">Aujourd'hui</SelectItem>
                <SelectItem value="week">Cette semaine</SelectItem>
                <SelectItem value="month">Ce mois</SelectItem>
                <SelectItem value="3months">3 derniers mois</SelectItem>
              </SelectContent>
            </Select>
            
            <Select value={transactionType} onValueChange={setTransactionType}>
              <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Type de mouvement" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Tous les mouvements</SelectItem>
                <SelectItem value="sale">Ventes</SelectItem>
                <SelectItem value="credit_sale">Ventes à crédit</SelectItem>
                <SelectItem value="restock">Réapprovisionnements</SelectItem>
                <SelectItem value="loss">Pertes</SelectItem>
                <SelectItem value="return">Retours</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        
        <Card className="p-6">
          {viewMode === "table" ? (
            <TransactionTable transactionType={transactionType} period={period} />
          ) : (
            <TransactionCharts transactions={transactions || []} />
          )}
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default History;